export const PRAXIA_CANDIDATE_TITLES = [
  'generalMedicine',
  'internalMedicine',
  'pediatrics',
  'surgery',
  'gynecology',
  'dentistryGeneralDentistry',
  'psychiatry',
  'orthopedics',
  'dermatology',
  'otorhinolaryngologyEnt',
  'ophthalmology',
  'radiology',
  'anesthesiology',
  'urology',
  'neurology',
  'cardiology',
  'gastroenterology',
  'oncology',
  'endocrinology',
  'pulmonology',
  'occupationalTherapist',
  'physicalTherapist',
  'osteopath',
  'speechTherapist',
];

export const PRAXIA_EMPLOYER_TITLES = [
  'medicalAssistantMfa',
  'dentalAssistantZfa',
  'intensiveCareTechnicalAssistance',
  'practiceStaff',
  'administrativeStaff',
  'medicalTechnicalAssistantMta',
  'medicalLaboratoryAssistantMtla',
  'pharmaceuticalTechnicalAssistantPta',
  'operationAssistant',
  'medicalAssistance',
  'medicalRadiologyAssistantMtra',
  'medicalAssistantForFunctionalDiagnostics',
  'anestheticAssistant',
  'surgicalTechnicalAssistant',
  'careerChanger',
  'occupationalTherapist',
  'physicalTherapist',
  'osteopath',
  'speechTherapist',
];
